export default function SectionHeading({ eyebrow, title, subtitle, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && <div className={`label-caps mb-4`}>{eyebrow}</div>}
      <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-ducs-cream leading-tight tracking-tight">
        {title}
      </h2>
      {align === "center" && <div className="gold-divider mx-auto mt-6" />}
      {subtitle && (
        <p className="mt-6 text-ducs-mist text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
